// flow weak

import React, {
    PureComponent,Component
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import DatePicker from 'react-datepicker';
  import {addDays}  from 'material-ui/DatePicker/dateUtils';
  import TimeField from 'react-simple-timefield';
  import { Table } from 'reactstrap';

  class BuddySalary extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      var today = new Date();
      this.state = {
        year:today.getFullYear(),
        month:today.getMonth()+1,
        venue_list: [],
        venue:this.props.venue ? this.props.venue : '',
        rent_type:'',
        header:[],
        months:[1,2,3,4,5,6,7,8,9,10,11,12],

      };
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.onSalaryUpdate = this.onSalaryUpdate.bind(this);
      this.handleChangeYear = this.handleChangeYear.bind(this);    
	  this.handleChangeMonth = this.handleChangeMonth.bind(this);
    }
  
    componentDidMount() {      
        this.getVenueList()  
    }

    handleChangeYear(event) {
        this.setState({year: event.target.value});
      }
    
      handleChangeMonth(event) {
        this.setState({month: event.target.value});
      }
  
    getVenueList(val){
        console.log('getVenueList')
        console.log(val)
        
        const url = `${getLocationOrigin()}/get_venue_list/get_venues_for_buddy/`;
        const options = {...defaultOptions};
   
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
            this.setState(
            {venue_list:data.result});
            })
          .catch(error => error);
        
    }

    getBuddyDetails(venue,month,year){
        if(venue){
            const url = `${getLocationOrigin()}/buddy/get_buddies_earning_detail_for_venue/?venue_id=${venue}&year=${year}&month=${month}`;
            const options = {...defaultOptions};

            return fetch(url, options)
                .then(checkStatus)
                .then(parseJSON)
                .then(data => {
                this.setState(
                {result:data.result,header:data.header});
                })
                .catch(error => error);
        }
        else{
            alert("Please Select Venue")
        }
    }

    onSalaryUpdate(event) {
      const role = event.target.name.split('_')[1];
      var index = event.target.name.split('_')[0];
      var input_type = event.target.name.split('_')[2]
      let buddy = {...this.state.result};

      if(input_type == "salary"){
        buddy[role]["salary"] = event.target.value;
      }
      if(input_type == "incentive"){
        buddy[role]["incentive"] = event.target.value;
      }

        buddy[role]["total"] = parseInt(buddy[role]["salary"])  + parseInt(buddy[role]["incentive"]);
      
      
      this.setState({result: buddy});
      console.log(event.target.name);
  
  
    }  
  
    

    handleChange(event) {
        const new_val = event.target;
        const name = new_val.name;
        console.log(new_val.value)
        if(name == 'venue'){
            this.setState({ venue:new_val.value})
            // this.getBuddyDetails(new_val.value)
        }

    }

    updateSalary() {
        const url = `${getLocationOrigin()}/buddy/update_salary/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                                    'month':this.state.month,
                                    'venue_id':this.state.venue,
                                    'year':this.state.year,
                                    'result':this.state.result});
      console.log('Going to fetch');
      return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {
          alert(response.message);
      })
      .catch(error => {
      console.log(error);
      alert(error.message);
                  });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.updateSalary();
      }

  
  
    
  
    render() {
      console.log('render')
      console.log(this.state.result)
      return(
        <div style={styles.container}>
         <div className="row col-md-8 table-bordered" style={styles.table} >
            <div style={styles.main_header} className="col-md-12 label_blue_1">
                Salary
            </div>
            
            {this.state.venue_list.length > 0 &&
            <div>
            <div style={styles.items} className="col-md-12">
                <div  style={styles.item_header} className="col-md-4">
                    <lable>Venue</lable>
                </div>
                <select name="venue"  className="col-md-8" style={styles.item_body} value={this.state.venue}
                    onChange={this.handleChange} disabled={this.props.venue? 'disabled':''}>
                    <option>-------</option>
                    {
                    this.state.venue_list.map((venue, index) => (
                    <option key={venue.id} value={venue.id}>{venue.name}</option>
                    ))
                    }
                </select>
        
            </div>

            <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-4">
                    Year
                  </div>
                  <select name="year" className="col-md-8" style={styles.item_body} value={this.state.year}
                    onChange={this.handleChangeYear}>
                      <option key={1} value={2020}>{2020}</option>
                      <option key={2} value={2021}>{2021}</option>
                  </select>
            </div>	

            <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-4">
                    Month
                  </div>
                  <select name="month" className="col-md-8" style={styles.item_body} value={this.state.month}
                    onChange={this.handleChangeMonth}>

                    {	
                      this.state.months.map((x,index) =>
                      <option key={x} value={x}>{x}</option>
                      		)
                      }
                  </select>
            </div>

            <div style={styles.button_submit} className="col-md-12">
                  <input className="button1" type="submit" value="Show Values" onClick={() => this.getBuddyDetails(this.state.venue,this.state.month,this.state.year)}/>
            </div>	

            {this.state.result &&
            <div style={styles.item_table}>
           		<Table name="targets_table">
                    <tr>
                        { 	
                            this.state.header.map((key, index) => 
                            <th style={styles.main_header} key={index} value={key}> {key} </th>
                            )
                        }
                    </tr>
                    
                    {Object.keys(this.state.result).map((key, index) => (
                        
                        <tr style={styles.item_body} key={index} value={key}>
                            <td style={styles.items}>{key}</td>
                            <td style={styles.items}>{this.state.result[key].buddy_type}</td>
                            <td> 
                                <input name={index + '_' + key + '_' + 'salary'} style={styles.input}  index={index} type="number" value={this.state.result[key].salary} onChange={this.onSalaryUpdate}/>  			
                            </td>		
                            <td> 
                                <input name={index + '_' + key + '_' + 'incentive'} style={styles.input}  index={index} type="number" value={this.state.result[key].incentive} onChange={this.onSalaryUpdate} />  			
                            </td>	
                            <td> 
                                <input name={index + '_' + key + '_' + 'total'} style={styles.input}  index={index} type="number" value={this.state.result[key].total} />  			
                            </td>		 
                        </tr>   
                           
                       )
                       )
                    }
				</Table>
				</div>
            }

            {this.state.result &&

				<div style={styles.button_submit} >
                  <input className="button1" type="submit" value="Update Salary" onClick={this.handleSubmit}/>
                </div>	
            }
            </div>
            }
            </div> 
        </div>
    );
    }
  }
  export default BuddySalary;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/buddySalary/index.js